<div class="content grid-1-auto md3-surface app-pad-top-none" [hidden]="TaskSummary?.taskDetails?.isLoading">
  <div class="content grid-1-auto">
    <div class="content flex-container lh-1-15">
      <div class="flex-row cols-3">
        <div class="flex-col flex-col-2 app-space-top md3-card-on-surface">
          <div class="content flex-container lh-1-15">
            <div class="flex-row cols-3">
              <div class="flex-col" #DivDetails>
                <h6>
                  <span>{{getRessource("Task.Text")}} {{TaskSummary?.taskDetails?.data?.vorgNr}}</span>
                  <app-exg-dropdown>
                    <ng-template #hostTemplate>
                      <i class="md-btn-circular fal fa-ellipsis-v" [class.disabled]="!isWorkflowActive()"
                         [tooltip]="!isWorkflowActive()?'Keine Workfloweinträge verfügbar':'Workflowmenü'"
                         flow="left"></i>
                    </ng-template>
                    <ng-template #contentTemplate let-popup>
                      <div *ngFor="let row of workFlowMenu">
                        <div class="list-row list-single-line  typo-small" style="cursor: pointer" (click)="row.click();popup.close();"
                             *ngIf="row.visible">{{row.caption}}</div>
                      </div>
                    </ng-template>
                  </app-exg-dropdown>
                </h6>

                <p class="typo-small">
                  <ng-container *ngIf="!editFunctions.editMode">
                    <label>Vorgangstyp</label>
                    <span>{{enumSvc.getEnumerationText(
                      TaskSummary?.taskDetails?.data?.vorg_enmName_VorgangTyp,
                      TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangTyp)}}</span>
                  </ng-container>
                  <ng-container *ngIf="editFunctions.editMode">
                    <exg-select [(ngModel)]="selectedVorgangTypIndex"
                                [list]="enumSvc.getEnumerationList(editFunctions?.editTaskModel?.vorg_enmName_VorgangTyp) "
                                listdisplay="enmText" [caption]="'Vorgangstyp'"
                                name="vorgTyp"
                                ></exg-select>
                  </ng-container>
                  <ng-container *ngIf="!editFunctions.editMode
                                && TaskSummary?.taskDetails?.data?.vorgVorgangSubTyp_enmIdent > 0
                                ">
                    <label>Vorgangssubtyp</label>
                    <span>{{enumSvc.getEnumerationText(
                      TaskSummary?.taskDetails?.data?.vorgVorgangSubTyp_enmName,
                      TaskSummary?.taskDetails?.data?.vorgVorgangSubTyp_enmIdent, true)}}</span>
                  </ng-container>
                  <ng-container *ngIf="editFunctions?.editMode && editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName !== ''">
                    <exg-select [(ngModel)]="selectedVorgangSubTypIndex"
                                [list]="enumSvc.getEnumerationList(editFunctions?.editTaskModel?.vorgVorgangSubTyp_enmName) "
                                listdisplay="enmText" [caption]="'Subtyp'"
                                name="vorgSubTyp"
                    ></exg-select>
                  </ng-container>
                  <label>Vorgangsstatus</label>
                  <span>
                    <strong>
                    {{enumSvc.getEnumerationText(
                      TaskSummary?.taskDetails?.data?.vorg_enmName_VorgangStatus,
                      TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus)}}
                    </strong>
                  </span>
                </p>

                <p class="typo-small">
                  <!-- Schadennummer -->
                  <ng-container
                    *ngIf="TaskSummary?.caseDetails?.data?.aueSchadenNr && TaskSummary?.caseDetails?.data?.aueSchadenNr.length > 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenNr")}}</label>
                    <span>{{TaskSummary?.caseDetails?.data?.aueSchadenNr}}</span>
                  </ng-container>

                  <!-- SchadenTyp -->
                  <ng-container
                    *ngIf="TaskSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_enmIdent_SchadenArt")}}</label>
                    <span>
                      <strong>{{
                        enumSvc.getEnumerationTextA(
                          TaskSummary?.caseDetails?.data?.aue_enmName_SchadenArt, TaskSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt
                        )}} ({{
                        enumSvc.getEnumerationText(TaskSummary?.caseDetails?.data?.aue_enmName_SchadenArt, TaskSummary?.caseDetails?.data?.aue_enmIdent_SchadenArt
                        )}})
                      </strong>
                    </span>
                  </ng-container>

                  <!-- Frist -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("Vorgang", "vorgFrist")}}</label>
                    <span>{{TaskSummary?.taskDetails?.data?.vorgFrist | excDate}}</span>
                  </ng-container>

                  <!-- Bearbeiter -->
                  <label>{{enumSvc.getFieldCaption("Vorgang", "vorg_oid_Bearbeiter")}}</label>
                  <ng-container
                    *ngIf="config.getOEByID(TaskSummary?.taskDetails?.data?.vorg_oid_Bearbeiter) as OE">
                    <span>
                          <app-organization-unit-box-view [showAllContacts]="0" [showAddress]="0"
                                                          [data]="OE">
                          </app-organization-unit-box-view>
                      <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeEditor()">
                        {{getResource('change')}}
                      </a>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="!TaskSummary?.taskDetails?.data?.vorg_oid_Bearbeiter ||
                  TaskSummary?.taskDetails?.data?.vorg_oid_Bearbeiter === '00000000-0000-0000-0000-000000000000'">
                    <span>
                        {{getResource('ChangeEditor.NoEditor')}}
                      <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeEditor()">
                        {{getResource('change')}}
                      </a>
                    </span>
                  </ng-container>
                  <!-- Co-Bearbeiter -->
                  <label>{{enumSvc.getFieldCaption("Vorgang", "vorgBearbeiterCo_oeID")}}</label>
                  <ng-container
                    *ngIf="config.getOEByID(TaskSummary?.taskDetails?.data?.vorgBearbeiterCo_oeID) as OE">
                    <span style="position: relative;">
                      <app-organization-unit-box-view [showAllContacts]="0" [showAddress]="0"
                                                      [data]="OE">
                      </app-organization-unit-box-view>
                      <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeCoEditor()">
                        {{getResource('change')}}
                      </a>
                      <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="deleteCoEditor()">
                        {{getResource('remove')}}
                      </a>
                    </span>
                  </ng-container>
                  <ng-container
                    *ngIf="!TaskSummary?.taskDetails?.data?.vorgBearbeiterCo_oeID ||
                    TaskSummary?.taskDetails?.data?.vorgBearbeiterCo_oeID == '00000000-0000-0000-0000-000000000000'">
                    <span>{{getResource('noneMessages.noSecondEditor')}}
                      <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeCoEditor()">
                      {{getResource('change')}}
                    </a>
                    </span>
                  </ng-container>
                  <!-- Auftragsdatum -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueAuftragsdatum")}}</label>
                    <span>{{TaskSummary?.caseDetails?.data?.aueAuftragsdatum | excDate}}</span>
                  </ng-container>

                  <!-- Schadendatum -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenDatum")}}</label>
                    <span>{{TaskSummary?.caseDetails?.data?.aueSchadenDatum | excDate}}</span>
                  </ng-container>

                  <!-- Schadenort -->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadenOrt")}}</label>
                    <span>
                            <ng-container *ngIf="TaskSummary?.Schadenort?.data as address">
                            <em>{{address.adrStr}} {{address.adrHNum}} </em>
                            <em>{{address.adrPlz}} {{address.adrOrt}}</em>
                          </ng-container>
                            <br/>
                          </span>
                  </ng-container>
                </p>
              </div>
              <div class="flex-col" #DivDetails2>
                <h6>{{getResource("Case.Text")}}
                  <!-- <i class="far fa-ellipsis-v md-btn-circular"></i>-->
                </h6>
                <p class="typo-small">
                  <!--Mandant OKZ-->
                  <ng-container
                    *ngIf="TaskSummary?.caseDetails?.data?.auMdtOKZ && TaskSummary?.caseDetails?.data?.auMdtOKZ?.length > 0">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "auMdtOKZ")}}</label>
                    <span>{{TaskSummary?.caseDetails?.data?.auMdtOKZ}}</span>
                  </ng-container>

                  <!--Auftraggeber-->
                  <ng-container
                    *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.au_oeID_Auftraggeber) as OE">
                    <label>{{enumSvc.getFieldCaption("Auftrag", "au_oeID_Auftraggeber")}}</label>
                    <span>
                       <app-organization-unit-box-view [data]="OE"
                                                       [showAddress]="userType === 1 ? 1 : 0"
                                                       [showContacts]="userType === 1"
                       ></app-organization-unit-box-view>
                    </span>
                  </ng-container>

                  <!-- Versicherungsnehmer -->
                  <ng-container *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_VN) as OE">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_VN")}}</label>
                    <span>
                             <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                            </span>

                  </ng-container>

                  <!-- Versicherungsart-->
                  <ng-container *ngIf="TaskSummary?.caseDetails?.data?.aue_enmIdent_Versicherungsart !== 0">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS",
                      "aue_enmIdent_Versicherungsart")}}</label>
                    <span>{{enumSvc.getEnumerationText(TaskSummary?.caseDetails?.data?.aue_enmName_Versicherungsart,
                      TaskSummary?.caseDetails?.data?.aue_enmIdent_Versicherungsart)}}</span>

                  </ng-container>

                  <!-- Ansprechpartner -->
                  <ng-container
                    *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_AnspPtnr) as OE">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aue_oeID_AnspPtnr")}}</label>
                    <span>
                           <ng-container
                             *ngIf="TaskSummary?.caseDetails?.data?.aue_oeID_VN === TaskSummary?.caseDetails?.data?.aue_oeID_AnspPtnr">
                             <span class="typo-small" style="padding: 0">{{getResource('identicalToPolicyholder')}}</span>
                           </ng-container>
                           <ng-container
                             *ngIf="TaskSummary?.caseDetails?.data?.aue_oeID_VN !== TaskSummary?.caseDetails?.data?.aue_oeID_AnspPtnr">
                              <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                           </ng-container>
                          </span>

                  </ng-container>

                  <!-- ReserveEXCON-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserve")}}</label>
                    <span>{{TaskSummary?.caseDetails?.data?.aueReserve | excCurrency: '€'}}</span>

                  </ng-container>

                  <!-- ReserveVU-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueReserveVU")}}</label>
                    <span>{{TaskSummary?.caseDetails?.data?.aueReserveVU | excCurrency: '€'}}</span>

                  </ng-container>

                  <!-- Schadensumme-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSchadensumme")}}</label>
                    <span>{{TaskSummary?.caseDetails?.data?.aueSchadensumme | excCurrency: '€'}}</span>

                  </ng-container>

                  <!-- Selbstbehalt-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueSelbstbehalt")}}</label>
                    <span>{{TaskSummary?.caseDetails?.data?.aueSelbstbehalt | excCurrency: '€'}}</span>

                  </ng-container>

                  <!-- Versicherungssumme-->
                  <ng-container>
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueVersicherungSumme")}}</label>
                    <span>{{TaskSummary?.caseDetails?.data?.aueVersicherungSumme | excCurrency: '€'}}</span>

                  </ng-container>

                  <!-- Letzter QS-Prüfer -->
                  <ng-container *ngIf="config.getOEByID(TaskSummary?.caseDetails?.data?.aue_oeID_letzterQSPruefer) as OE">
                    <label>{{enumSvc.getFieldCaption("AuftragE_EIS", "aueLetzterQSPruefer")}}</label>
                    <span>
                      <app-organization-unit-box-view [data]="OE"></app-organization-unit-box-view>
                      <a *ngIf="excSecurity.isFeatured('TASKDISPO')" href="javascript:void(0)"
                         style="color: var(--c-dark);text-decoration: none; display:inline"
                         (click)="changeLastQSAuditor()">
                        {{getResource('change')}}
                      </a>
                    </span>
                  </ng-container>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-col app-space-top md3-card-on-surface layout-auto-1" #DivVerlauf style="min-height: 360px">
          <h6>
            {{getResource('Tabs.Progress.HeaderText')}}
          </h6>
          <ng-container *ngIf="resized">
            <!-- Verlauf -->
            <div class="content app-space_025">
              <app-tab-task-flowtable
                [ConfigFlowTable]="config.flowTable"
                [SummaryFlowTable]="TaskSummary?.flowTable"
              >
              </app-tab-task-flowtable>
            </div>
          </ng-container>
          <ng-container *ngIf="!resized">
            <div class="content">
              <div class="splash loading">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="flex-row app-space-top cols-3">
        <div class="flex-col md3-card-on-surface">
          <div class="content flex-container lh-1-15">
            <div class="flex-row cols-3">
              <div class="flex-col app-space-top">
                <p class="typo-small">
                  <ng-container *ngIf="!editFunctions.editMode">
                    <label>{{enumSvc.getFieldCaption("Vorgang", "vorgBeschreibung")}}</label>
                    <ng-container *ngIf="!TaskSummary?.taskDetails?.data?.vorgBeschreibung">
                      <span style="white-space: pre-wrap">{{getResource('noneMessages.noDescription')}}</span>
                    </ng-container>
                    <ng-container *ngIf="TaskSummary?.taskDetails?.data?.vorgBeschreibung">
                      <span style="white-space: pre-wrap">{{TaskSummary?.taskDetails?.data?.vorgBeschreibung}}</span>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="editFunctions.editMode">
                    <exg-textarea [(ngModel)]="editFunctions.editTaskModel.vorgBeschreibung" [caption]="enumSvc.getFieldCaption('Vorgang', 'vorgBeschreibung')"
                                  type="text" name="vorgBeschreibung">
                    </exg-textarea>
                  </ng-container>




                </p>
              </div>
              <div class="flex-col app-space-top">
                <p class="typo-small">
                  <!-- Objektbild -->
                  <ng-container>
                    <label>Objektbild</label>
                    <span>
                        <img alt="thumb" width="120" height="120" class="app-cursor-pointer"
                             [ngClass]="{'placeholder-img': (!TaskSummary?.caseDetails?.data?.aueObjektbild_dokID || TaskSummary?.caseDetails?.data?.aueObjektbild_dokID === '00000000-0000-0000-0000-000000000000')}"
                             src="{{(!TaskSummary?.caseDetails?.data?.aueObjektbild_dokID || TaskSummary?.caseDetails?.data?.aueObjektbild_dokID === '00000000-0000-0000-0000-000000000000')
                             ? 'assets/images/NoImage.png'
                             : excRest.computeUrl(
                             'ImageThumbnailBig',
                              {thumb: 120, dokID: TaskSummary?.caseDetails?.data?.aueObjektbild_dokID})}}"
                             (click)="showObjectImageUpdateModal()"/>
                      </span>
                  </ng-container>
                </p>
              </div>
              <div class="flex-col">
              </div>
            </div>
            <div class="flex-row cols-3">
              <div class="flex-col">
                <p class="typo-small">
                  <!-- CRD -->
                  <label>{{enumSvc.getFieldCaption("All", '%CRD')}}</label>
                  <span>
                    {{TaskSummary?.taskDetails?.data?.vorgCRD | excDate: getGlobal('DateFormat')}}
                    ({{TaskSummary?.taskDetails?.data?.vorgCRU}})
                  </span>

                  <!-- LCD -->
                  <label>{{enumSvc.getFieldCaption("All", '%LCD')}}</label>
                  <span>
                    {{TaskSummary?.taskDetails?.data?.vorgLCD | excDate: getGlobal('DateFormat')}}
                    ({{TaskSummary?.taskDetails?.data?.vorgLCU}})
                  </span>
                </p>
              </div>
              <div class="flex-col">
                <p class="typo-small">
                  <!-- Letzter historisierter Eintrag -->
                  <label>Letzter historisierter Eintrag</label>
                  <span *ngIf="TaskSummary?.historyTable?.data[0]">
                    {{TaskSummary?.historyTable?.data[0]?.lnkCRD | excDate: getGlobal('DateTimeFormatShort')}}
                    ({{TaskSummary?.historyTable?.data[0]?.lnkCRU}})
                  </span>
                  <span *ngIf="!TaskSummary?.historyTable?.data[0]">
                    {{getRessource('noneMessages.noEntries')}}
                  </span>
                </p>
              </div>
              <div class="flex-col">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-row md3-card-on-surface app-space-top"
           *ngIf="excSecurity.isFeatured('SCHEDULEREAD')">
        <div #DivSchedule
             class="flex-col app-space-bottom_1">
          <div class="grid-1-auto">
            <h6>{{getResource("Schedule.Text")}} </h6>
            <button [disabled]="!excSecurity.isFeatured('SCHEDULECREATE')"
                    class="md-btn" (click)="createNewTaskWorklist()">
              Ablaufpunkt erstellen
            </button>
          </div>
          <ng-container *ngIf="!TaskSummary?.workList?.data || TaskSummary?.workList?.isEmpty">
            <p>Es wurde noch kein Ablaufplan erstellt.</p>
          </ng-container>
          <ng-container *ngIf="showApiDivTable">
            <ng-container *ngIf="TaskSummary?.workList?.data && !TaskSummary?.workList?.isEmpty">
              <div class="app-subarea" style="margin:0 1rem">
                <exg-data-table #VCAP
                                [allowSingleSelection]="false" [displayState]="0"
                                [rowSource]="TaskSummary?.workList?.data"
                                selectKey="apiID"
                                containerClass="grid cols-24"

                                (RowDblClick)="showWorklistUpdateModal($event)">
                  <ng-template #headerTemplate>
                    <div class="span-3">
                      #
                    </div>
                    <div class="span-5">
                      {{enumSvc.getFieldCaption("Ablaufplan", "apiBezeichnung")}}
                    </div>
                    <div class="span-3">
                      {{enumSvc.getFieldCaption("Ablaufplan", "apiSollDatum")}}
                    </div>
                    <div class="span-3">
                      {{enumSvc.getFieldCaption("Ablaufplan", "apiPlanDatum")}}
                    </div>
                    <div class="span-3">
                      {{enumSvc.getFieldCaption("Ablaufplan", "apiIstDatum")}}
                    </div>
                    <div class="span-7">
                      {{enumSvc.getFieldCaption("Ablaufplan", "apiKommentar")}}
                    </div>
                  </ng-template>
                  <ng-template #rowTemplate let-row>
                    <div class="span-3" style="padding-bottom: 8px">
                      <span class="typo-small"
                            [class.app-textdone]="row.apiFreigabe">
                        {{row.apiSequence}}
                      </span>
                      <span flow="right"
                            [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiFreigabe')"
                            style="margin-left: 4px">
                        <i class="search-filter-action disabled fa-clipboard-check"
                           [class.app-fa-duotone-green]="row.apiFreigabe"
                           [class.fa-duotone]="row.apiFreigabe"
                           [class.fa-light]="!row.apiFreigabe">
                        </i>
                      </span>
                      <ng-container *ngIf="excSecurity.isFeatured('SCHEDULEMGMT')">
                        <span flow="right"
                              [tooltip]="getRessource('inProof')"
                              style="margin-left: 2px">
                          <i class="search-filter-action disabled fa-magnifying-glass"
                             [class.fa-duotone]="row.apiPruefen"
                             [class.fa-light]="!row.apiPruefen">
                          </i>
                        </span>
                        <span flow="right"
                              [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiMonitoring')"
                              style="margin-left: 2px">
                          <i class="search-filter-action disabled fa-monitor-waveform"
                             [class.fa-duotone]="row.apiMonitoring"
                             [class.fa-light]="!row.apiMonitoring">
                          </i>
                        </span>
                        <span flow="right"
                              [tooltip]="getRessource('Ablaufplan.isapiCustom')"
                              style="margin-left: 2px"
                              *ngIf="row.apiCustom">
                          <i class="search-filter-action disabled fa-duotone fa-list-radio">
                          </i>
                        </span>
                        <span flow="right"
                              [tooltip]="getRessource('Ablaufplan.isNotapiCustom')"
                              style="margin-left: 2px"
                              *ngIf="!row.apiCustom">
                          <i class="search-filter-action disabled fa-user-pen fa-duotone">
                          </i>
                        </span>
                      </ng-container>
                    </div>
                    <div class="span-5 typo-small"
                         [class.app-textdone]="row.apiFreigabe">
                      {{row.apiBezeichnung}}
                    </div>
                    <div class="span-3">
                      <span class="typo-small"
                            [class.app-textdone]="row.apiFreigabe">
                        {{row.apiSollDatum | excDate}}
                      </span>
                      <span [tooltip]="row.apiSollDatumWTooltip"
                            *ngIf="row.apiSollDatumShowWarning"
                            flow="right">
                        <i class="fa-duotone fa-triangle-exclamation"
                           style="--fa-primary-color: #f1ea27; --fa-secondary-color: #e64805;">
                        </i>
                      </span>
                    </div>
                    <div class="span-3">
                      <span class="typo-small"
                            [class.app-textdone]="row.apiFreigabe">
                        {{row.apiPlanDatum | excDate}}
                      </span>
                      <span [tooltip]="row.apiPlanDatumWTooltip"
                            *ngIf="row.apiPlanDatumShowWarning"
                            flow="right">
                        <i class="fa-duotone fa-triangle-exclamation"
                           style="--fa-primary-color: #f1ea27; --fa-secondary-color: #e64805;">
                        </i>
                      </span>
                    </div>
                    <div class="span-3">
                      <span class="typo-small"
                            [class.app-textdone]="row.apiFreigabe">
                        {{row.apiIstDatum | excDate}}
                      </span>
                    </div>
                    <div class="span-6 typo-small"
                         [class.app-textdone]="row.apiFreigabe">
                      {{row.apiKommentar}}
                    </div>
                    <div class="typo-center">
                      <i class="search-action fa-duotone fa-pencil" (click)="showWorklistUpdateModalWithRow(row)"></i>
                    </div>
                  </ng-template>
                </exg-data-table>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!showApiDivTable">
            <exg-data-list class="list"
                           [allowSingleSelection]="true"
                           [displayState]="0"
                           [rowSource]="TaskSummary?.workList?.data"
                           [selectKey]="config.worklist.selectKey"
                           [selectSource]="config.worklist.selectedRow"
                           (RowChange)="config.worklist.selectionChanged($event)"
                           (RowDblClick)="showWorklistUpdateModal($event)">
              <ng-template #rowTemplate let-row>
                <div class="list-row  list-row-1-auto app-list">
                  <div style="padding-bottom: 8px">
                    <span class=""
                          [class.app-textdone]="row.apiFreigabe">
                      {{row.apiSequence}}
                    </span>
                    <span flow="right"
                      [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiFreigabe')"
                      style="margin-left: 4px">
                      <i class="search-filter-action disabled fa-clipboard-check"
                         [class.app-fa-duotone-green]="row.apiFreigabe"
                         [class.fa-duotone]="row.apiFreigabe"
                         [class.fa-light]="!row.apiFreigabe">
                      </i>
                    </span>
                    <ng-container *ngIf="excSecurity.isFeatured('SCHEDULEMGMT')">
                      <span flow="left"
                            [tooltip]="getRessource('inProof')"
                            style="margin-left: 2px">
                        <i class="search-filter-action disabled fa-magnifying-glass"
                           [class.fa-duotone]="row.apiPruefen"
                           [class.fa-light]="!row.apiPruefen">
                        </i>
                      </span>
                      <span flow="left"
                          [tooltip]="enumSvc.getFieldCaption('Ablaufplan', 'apiMonitoring')"
                          style="margin-left: 2px">
                        <i class="search-filter-action disabled fa-monitor-waveform"
                           [class.fa-duotone]="row.apiMonitoring"
                           [class.fa-light]="!row.apiMonitoring">
                        </i>
                      </span>
                    </ng-container>
                    <div class="grid-auto-1">
                      <div class="width-200"
                           [class.app-textdone]="row.apiFreigabe">
                        {{enumSvc.getFieldCaption('Ablaufplan', 'apiBezeichnung')}}
                      </div>
                      <div class=""
                           [class.app-textdone]="row.apiFreigabe">
                        {{row.apiBezeichnung}}
                      </div>
                      <div class="width-200"
                           [class.app-textdone]="row.apiFreigabe">
                        {{enumSvc.getFieldCaption('Ablaufplan', 'apiSollDatum')}}
                      </div>
                      <div class=""
                           [class.app-textdone]="row.apiFreigabe">
                        <ng-container *ngIf="row.apiSollDatum">
                          {{row.apiSollDatum |excDate}}
                        </ng-container>
                        <ng-container *ngIf="!row.apiSollDatum">
                          -
                        </ng-container>
                      </div>
                      <div class="width-200"
                           [class.app-textdone]="row.apiFreigabe">
                        {{enumSvc.getFieldCaption('Ablaufplan', 'apiPlanDatum')}}
                      </div>
                      <div class=""
                           [class.app-textdone]="row.apiFreigabe">
                        <ng-container *ngIf="row.apiPlanDatum">
                         {{row.apiPlanDatum |excDate}}
                        </ng-container>
                        <ng-container *ngIf="!row.apiPlanDatum">
                          -
                        </ng-container>
                      </div>
                      <div class="width-200"
                           [class.app-textdone]="row.apiFreigabe">
                        {{enumSvc.getFieldCaption('Ablaufplan', 'apiIstDatum')}}
                      </div>
                      <div class=""
                           [class.app-textdone]="row.apiFreigabe">
                        <ng-container *ngIf="row.apiIstDatum">
                          {{row.apiIstDatum | excDate}}
                        </ng-container>
                        <ng-container *ngIf="!row.apiIstDatum">
                            -
                        </ng-container>
                      </div>
                      <ng-container *ngIf="row.apiKommentar && row.apiKommentar.length">
                        <div class="width-200"
                             [class.app-textdone]="row.apiFreigabe">
                          {{enumSvc.getFieldCaption('Ablaufplan', 'apiKommentar')}}
                        </div>
                        <div class=""
                             [class.app-textdone]="row.apiFreigabe">
                          {{row.apiKommentar}}
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="typo-center">
                    <i class="search-action fa-duotone fa-pencil" (click)="showWorklistUpdateModalWithRow(row)"></i>
                  </div>
                </div>
              </ng-template>
            </exg-data-list>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="content drawer-container right app-table-drawer" style="padding-bottom: .5rem;">
      <div [ngClass]="{'visible': rightDrawerVisible }"
           class="drawer-content md3-card-on-surface app-space-right_0 app-space-top">
        <div class="content width-500">
          <div *ngIf="TaskSummary?.taskDetails?.isLoading" class="splash loading">
            <div class="spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <exg-tab [hidden]="TaskSummary?.taskDetails?.isLoading" #VCrightTabControl [header]="rightTabs">
            <ng-template #pages>
              <!-- 1 - Details-->
              <div class="content">
                <!-- 1 - Details-->
                <app-drawer-task-details *ngIf="TaskSummary && !TaskSummary.isLoading"
                                         [data]="TaskSummary.taskDetails?.data"
                                         [oeList]="TaskSummary.oeList?.data"
                                         [Schadenort]="TaskSummary.Schadenort?.data">
                </app-drawer-task-details>
                <div class="search-filter-seperator"></div>
                <app-drawer-case-details *ngIf="TaskSummary && !TaskSummary.isLoading"
                                         [data]="TaskSummary.caseDetails?.data"
                                         [oeList]="TaskSummary.oeList?.data"
                                         [Schadenort]="TaskSummary.Schadenort?.data">
                </app-drawer-case-details>
              </div>
              <!--2 - Verlauf -->
	            <div class="content">
		            <app-tab-task-flowtable
			            [ConfigFlowTable]="config.flowTable"
			            [SummaryFlowTable]="TaskSummary?.flowTable"
			            [Events]="Events">
		            </app-tab-task-flowtable>
	            </div>
              <!--3 - Anhänge -->
	            <div class="content">
		            <app-tab-task-attachment
			            [entityID]="TaskSummary?.ID"
			            [SummaryAttachmentTable]="TaskSummary?.attachmentJagTable"
			            [ConfigAttachmentTable]="config.attachmentJagTable"
			            [Events]="Events">
		            </app-tab-task-attachment>
	            </div>
              <!--4 - Vorgänge-->
	            <div class="content">
		            <exg-data-list #VCVorganglist
		                           selectKey="vorgID"
		                           [displayState]="TaskSummary?.taskList?.data && TaskSummary?.taskList?.data.length > 0 ? 0 : 2"
		                           [rowSource]="TaskSummary?.taskList.data"
		                           [selectSourceRows]="config.taskList.selectedObjects"
		                           (RowChange)="config.taskList.rowChange($event)"
		                           (ItemSelect)="config.taskList.itemSelect($event)">
			            <ng-template #rowTemplate let-task>
				            <div class="list-row-auto-1"
				                 (dblclick)="onClickOpenTaskCheckview(task)"
				                 [class.active]="config.taskList.selectedObjects[0] === task">
					            <div></div>
					            <div class="layout-auto-1-auto-grid-1-auto grid typo-small">
						            <div class="list-metadata" style="margin-left:0">
							            <div>
								            {{enumSvc.getEnumerationText('VorgangStatus', task.vorg_enmIdent_VorgangStatus)}} -
								            {{enumSvc.getEnumerationText('VorgangTyp', task.vorg_enmIdent_VorgangTyp)}}
							            </div>
							            <div>Auftraggeber: {{task.auAuftraggeberShort}} Schadenart: {{enumSvc.getEnumerationText('Schadenart', task.aue_enmIdent_SchadenArt)}}</div>
						            </div>
						            <div class="list-metadata ">
							            <div
								            class="typo-right">{{task.vorgLCD | excDate: 'Globals.DateTimeFormatShort'}}
							            </div>
						            </div>
						            <div style="height: 30px">
                                <span class="typo-center">
                                  <span [tooltip]="'Nicht Geprüft'" flow="right">
                                    <i class="fa-solid fa-xmark c-red" style="font-size: 14px" *ngIf="!task.vorgCKD"></i>
                                  </span>
                                  <span [tooltip]="'Geprüft'" flow="right">
                                    <i class="fa-solid fa-check c-green" style="font-size: 14px" *ngIf="task.vorgCKD"></i>
                                  </span>
                                </span>
							            <span class="app-space-left">
                                  <strong>{{task.vorgNr}}</strong>
                                </span>
						            </div>
						            <div class="typo-right">
							            <i class="search-action fa-regular fa-chevron-right"
							               *ngIf="config.taskList.selectedObjects[0] === task"
							               (click)="onClickOpenTaskCheckview(task)">
							            </i>
						            </div>
						            <div class="span-2 typo-container-s-s-q app-space-left_none">
							            <ng-container *ngIf="task.vorgBeschreibung && task.vorgBeschreibung.length > 0">
                                  <span style="width: 148px">
                                    {{enumSvc.getFieldCaption('Vorgang', 'vorgBeschreibung')}}:
                                  </span>
								            <span class="typo-left"
								                  *ngIf="config.taskList.selectedObjects[0] === task">
                                    {{task.vorgBeschreibung}}
                                  </span>
								            <span class="typo-left"
								                  *ngIf="config.taskList.selectedObjects[0] !== task">
                                    {{task.vorgBeschreibung.slice(0, 48)}}
									            {{task.vorgBeschreibung.length > 48 ? '...' : ''}}
                                  </span>
								            <q></q>
							            </ng-container>
							            <ng-container *ngIf="task.vorgBearbeiter && task.vorgBearbeiter.length > 0">
                                  <span style="width: 148px">
                                    {{enumSvc.getFieldCaption('Vorgang', 'vorgBearbeiter')}}:
                                  </span>
								            <span class="typo-left">
                                    {{task.vorgBearbeiter}}
                                  </span>
								            <q></q>
							            </ng-container>
						            </div>
					            </div>
				            </div>
			            </ng-template>
		            </exg-data-list>
	            </div>
              <!--6 - Receipt -->
              <div class="content">
                <app-tab-task-receipt
                  *ngIf="!TaskSummary?.taskDetails?.isLoading"
                  [ConfigReceiptTable]="config.receiptList"
                  [SummaryReceiptTable]="TaskSummary?.receiptList"
                  [Events]="Events">
                </app-tab-task-receipt>
              </div>
              <!--7 - Fragen-->
              <div class="content">
                <div class="layout-1-auto">
                  <div class="content app-subarea">
                    <exg-data-list [allowSingleSelection]="false"
                                   [rowSource]="TaskSummary?.dialogueQuestions?.data"
                                   selectKey="dfID">
                      <ng-template #rowTemplate let-row>
                        <div class="list-row list-single-line-auto-1 typo-small">
                          <div><strong>{{row.dfText}}</strong></div>
                          <div class="list-secondary-text"
                               *ngIf="row.deValue && row.deValue.length > 0">{{row.deValue}}</div>
                          <div class="list-secondary-text" style="font-style: italic"
                               *ngIf="!row.deValue || row.deValue.length === 0">
                            &lt;&lt;{{getRessource('noneMessages.noAnswerer')}}&gt;&gt;
                          </div>
                        </div>
                      </ng-template>
                    </exg-data-list>
                  </div>
                  <div>
                  </div>
                </div>
              </div>
              <!--5 - Fragebögen-->
              <!--<div></div>-->
              <!--5 - PhotoDoc-->
	            <div class="content">
		            <ng-container *ngIf="TaskSummary?.photoDocumentation?.data">
			            <exg-data-list #PhotoDocList
			                           selectKey="pdID"
			                           [displayState]="config.photoDocumentation.isLoading ? 1 : (TaskSummary?.photoDocumentation?.data && TaskSummary?.photoDocumentation?.data.length > 0 ? 0 : 2)"
			                           [rowSource]="TaskSummary.photoDocumentation.data"
			                           [selectSourceRows]="config.photoDocumentation.selectedObjects">
				            <ng-template #rowTemplate let-pd>
					            <div class="list-row-auto-1">
						            <div></div>
						            <div class="grid-1-auto">
							            <div class="layout-auto-1">
								            <span>{{pd.pdName}}.pdf</span>
								            <span [tooltip]="pd.pdDescription" class="list-metadata" style="margin-left: 0;">{{pd.pdDescription}}</span>
							            </div>
							            <div class="typo-right typo-small">
								            {{pd.pdLCD | excDate: getGlobal('DateTimeFormatShort')}}
								            {{pd.pdLCU}}
							            </div>
							            <div class="typo-left typo-small">
								            {{enumSvc.getEnumerationText('PhotoDocumentationStatus', pd.pdPhotoDocumentationStatus_enmIdent)}}
							            </div>
							            <div class="typo-right">
								            <i [tooltip]="'Löschen'" class="search-action fal fa-trash" (click)="deletePhotoDoc(pd)"></i>
								            <i [tooltip]="'Editieren'" class="search-action fal fa-file-pen" (click)="openExistingPhotoDoc(pd)"></i>
								            <i [tooltip]="'Beschreibung editieren'" class="search-action fal fa-pen" (click)="openPhotoDocEditTextModal(false, pd)"></i>
								            <i [tooltip]="'Download'"  class="search-action fal fa-download" (click)="config.downloadPhotoDocumentation(pd.pdID)"></i>
							            </div>
						            </div>
					            </div>
				            </ng-template>
			            </exg-data-list>
		            </ng-container>
	            </div>
              <!--5 - CalculateVersion-->
	            <div class="content">
		            <ng-container *ngIf="TaskSummary?.calculationVersion && TaskSummary?.calculationVersion?.data">
			            <exg-data-list #VCVorganglist
			                           selectKey="vorgID"
			                           [displayState]="0"
			                           [rowSource]="TaskSummary?.calculationVersion?.data || []"
			            >

				            <ng-template #rowTemplate let-calcVersion>
					            <div class="list-row list-row-auto-1-auto app-cursor-pointer"
					                 (click)="createNewCalculationVersion(calcVersion)">
						            <div></div>
						            <div class="">
							            <div class="list-primary-text">{{calcVersion.cvName}}</div>
							            <div class="list-secondary-text">{{calcVersion.cvDescription}}</div>
						            </div>
						            <div class="list-metadata">
							            <div class="typo-right">{{calcVersion.cvCRD | excDate: 'dd.MM.yyyy HH:mm'}}</div>
							            <div class="typo-right">{{calcVersion.cvCRU}}</div>
						            </div>
					            </div>
				            </ng-template>
			            </exg-data-list>
		            </ng-container>
	            </div>
            </ng-template>
          </exg-tab>
        </div>
      </div>
    </div>
  </div>
  <div class="md3-card-on-surface app-space-top app-height-auto app-drawer" style="overflow: visible">
    <ng-container *ngIf="excSecurity.isFeatured('TASKREAD')">
      <i (click)="rightDrawerVisible = !rightDrawerVisible"
         class="search-filter-action fal fa-info"
         [tooltip]="getRessource('tooltip.openDetails')"
         flow="left"></i>
      <i class="search-filter-seperator"></i>
    </ng-container>
    <ng-container *ngIf="excSecurity.isFeatured('CASEREAD')">
      <i *ngIf="excSecurity.isFeatured('CASEREAD')"
         (click)="openCase()"
         class="search-filter-action fal fa-folder"
         [tooltip]="getRessource('tooltip.openCase')"
         flow="left"></i>
	    <i class="search-filter-seperator"></i>
    </ng-container>
    <i (click)="openWorkspaceV2()"
       class="search-filter-action fal fa-code"
       [tooltip]="getRessource('tooltip.openWorkspace')" flow="left">
    </i>
    <i class="search-filter-seperator"></i>
    <app-exg-dropdown>
      <ng-template #hostTemplate>
        <i class="search-filter-action fal fa-ellipsis-v"
           [class.disabled]="!isWorkflowActive()"
           [tooltip]="!isWorkflowActive()
           ? getRessource('noneMessages.noWorkflow')
           : getRessource('tooltip.WorkflowMenu')" flow="left">
        </i>
      </ng-template>
      <ng-template #contentTemplate let-popup>
        <div *ngFor="let row of workFlowMenu">
          <div class="list-row list-single-line  typo-small" style="cursor:pointer" (click)="row.click(); popup.close()"
               *ngIf="row.visible">{{row.caption}}</div>
        </div>
      </ng-template>
    </app-exg-dropdown>
    <!--Editing Buttons-->
    <i class="search-filter-action fal fa-pencil"
       *ngIf="!editFunctions.editMode && excSecurity.isFeatured('TASKEDIT')"
       (click)="editFunctions.enterEditMode(this.TaskSummary.taskDetails.data)"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Vorgang bearbeiten'"
       flow="left"></i>
    <i class="search-filter-action fal fa-floppy-disk"
       *ngIf="editFunctions.editMode && excSecurity.isFeatured('TASKEDIT')"
       (click)="this.saveEdit(this.TaskSummary.taskDetails.data)"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Bearbeitung speichern'"
       flow="left"></i>
    <i class="search-filter-action fal fa-xmark"
       (click)="editFunctions.cancelEdit(this.TaskSummary.taskDetails.data);"
       *ngIf="editFunctions.editMode && excSecurity.isFeatured('TASKEDIT')"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Bearbeitung abbrechen'"
       flow="left"
    ></i>
    <i class="search-filter-seperator"></i>
    <app-exg-dropdown position="underleft"
                      [adaptiveHeightActive]="true"
                      [adaptiveHeightOffset]="400"
                      [disabled]="TaskSummary?.isLoading">
      <ng-template #hostTemplate>
        <i class="search-filter-action fal fa-plus"
           [tooltip]="getGlobal('Add')" flow="left"
           [class.disabled]="TaskSummary?.isLoading"></i>
      </ng-template>
      <ng-template #contentTemplate let-popup>
        <div class="content" style="max-height: 500px">
          <div (click)="config.newReport(); popup.close();"
               *ngIf="excSecurity.isFeatured('REPORTCREATE')"
               class="md-menu-item">
            Bericht
          </div>
          <!-- Questionnaire Creation -->
          <ng-container *ngIf="TaskSummary && TaskSummary.questionnaireConfigurations && TaskSummary.questionnaireConfigurations.data
            && TaskSummary.questionnaireConfigurations.data.length > 0
            && excSecurity.isFeatured('RQUESTVCREATE')">
            <ng-container *ngIf="TaskSummary?.questionnaireConfigurations?.data?.length === 1; else multipleConfigElements">
              <ng-container *ngFor="let row of TaskSummary?.questionnaireConfigurations?.data">
                <div (click)="createNewQuestionnaireVersion(row.qcnfID);popup.close();"
                     class="md-menu-item">Fragebogen {{row.qcfgName}}</div>
              </ng-container>
            </ng-container>
            <ng-template #multipleConfigElements>
              <app-exg-dropdown  [adaptiveHeightActive]="true">
                <ng-template #hostTemplate>
                  <div class="md-menu-item"
                       *ngIf="excSecurity.isFeatured('RQUESTVCREATE')">
                    Fragebögen...
                  </div>
                </ng-template>
                <ng-template #contentTemplate let-popup>
                  <ng-container *ngFor="let row of TaskSummary?.questionnaireConfigurations?.data">
                    <div (click)="createNewQuestionnaireVersion(row.qcnfID);popup.close();"
                         class="md-menu-item typo-left">{{row.qcfgName}}</div>
                  </ng-container>
                </ng-template>
              </app-exg-dropdown>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="excSecurity.isFeatured('MSGCREATE')">
            <div *ngIf="!(TaskSummary?.defaultMessages?.data.length > 0)"
                 (click)="config.newMessage(); popup.close();"
                 class="md-menu-item">
              Nachricht
            </div>
            <app-exg-dropdown *ngIf="TaskSummary?.defaultMessages?.data.length > 0"  [adaptiveHeightActive]="true">
              <ng-template #hostTemplate>
                <div class="md-menu-item">Nachricht...</div>
              </ng-template>
              <ng-template #contentTemplate let-popup>
                <div (click)="config.newMessage();popup.close();" class="md-menu-item typo-left">Leere Nachricht</div>
                <ng-container>
                  <ng-container *ngFor="let row of TaskSummary?.defaultMessages?.data">
                    <div (click)="config.newDefaultMessage(row.dmsgID);popup.close();"
                         class="md-menu-item typo-left">{{row.dmsgBezeichnung}}</div>
                  </ng-container>
                </ng-container>
              </ng-template>
            </app-exg-dropdown>
          </ng-container>
          <div *ngIf="excSecurity.isFeatured('NTZEDIT')"
               (click)="config.newNote();popup.close();" class="md-menu-item">
            Notiz
          </div>
          <div (click)="config.showUploadReceiptModal(); popup.close();"
               *ngIf="excSecurity.isFeatured('RECEIPTCREATE')"
               class="md-menu-item">
            <!-- 	         (excSecurity.isFeatured('DLUSR') && TaskSummary?.taskDetails?.data?.vorg_enmIdent_VorgangStatus <= 4) -->
            {{getGlobal('Receipt')}}
          </div>
          <div (click)="config.showAttachmentUploadModal(); popup.close();"
               *ngIf="excSecurity.isFeatured('DOCUMENTCREATE')"
               class="md-menu-item">
            Anlage
          </div>
          <app-exg-dropdown *ngIf="TaskSummary?.documentTemplate.data.length > 0"  [adaptiveHeightActive]="true">
            <ng-template #hostTemplate>
              <div class="md-menu-item"
                   *ngIf="excSecurity.isFeatured('TASKFORMCREATE')">
                Formular...
              </div>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <ng-container *ngFor="let row of TaskSummary?.documentTemplate?.data">
                <div (click)="config.documentTemplateDownload(row.dotID); popup.close();"
                     class="md-menu-item typo-left">{{row.dotName}}</div>
              </ng-container>
            </ng-template>
          </app-exg-dropdown>
        </div>
      </ng-template>
    </app-exg-dropdown>
    <i class="search-filter-action fa-light fa-folders"
       *ngIf="excSecurity.isFeatured('DOCUMENTMGMT')"
       (click)="openFileOverview()"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Dokumenten Manager'"
       flow="left"></i>
    <i class="search-filter-action fal fa-image"
       *ngIf="excSecurity.isFeatured('DOKVIEWER')"
       (click)="config.showAttachmentPreview()"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Anlagen ansehen'"
       flow="left"></i>
    <i class="search-filter-action fal fa-file-image"
       [tooltip]="'Neue Bilddokumentation'" flow="left"
       [class.disabled]="TaskSummary?.isLoading"
       (click)="createNewPhotoDoc()"
       *ngIf="excSecurity.isFeatured('RPHOTOCREATE')"
    ></i>
    <i class="search-filter-seperator"></i>
    <i (click)="config.showHistory()" class="search-filter-action {{getResource('Tabs.History.Icon')}}"
       *ngIf="excSecurity.isFeatured('TASKREAD')"
       [class.disabled]="TaskSummary?.isLoading"
       [tooltip]="'Historie'" flow="left"></i>
	  <i class="search-filter-action fal fa-list-timeline"
	     *ngIf="excSecurity.isFeatured('HISTORYEXTREAD')"
	     (click)="OpenDetailHistoryModal()"
       [class.disabled]="TaskSummary?.isLoading"
	     [tooltip]="'History'"
	     flow="left"></i>
    <i class="search-filter-seperator"></i>
    <ng-container *ngIf="VCrightTabControl.selectedtab === 3
                      && rightDrawerVisible
                      && !TaskSummary?.isLoading">
      <!--       <i (click)="config.openCheckView()" -->
      <!--          [tooltip]="getRessource('Receipt.openCheckview')" flow="left" -->
      <!--          [class.disabled]="!config.receiptList.selectedRow && rightDrawerVisible" -->
      <!--          class="search-filter-action far fa-file-search"></i> -->
      <!--       <i (click)="config.openCheckViewCollection();" -->
      <!--          [tooltip]="getRessource('Receipt.openCheckviewCollection')" flow="left" -->
      <!--          class="search-filter-action far fa-brackets " -->
      <!--          [class.disabled]="config.receiptList.state !== 0"> -->
      <!--       </i> -->
      <app-exg-dropdown>
        <ng-template #hostTemplate>
          <i class="fal fa-file-chart-line search-filter-action"
             [class.disabled]="!(TaskSummary?.receiptList?.data
                                 && TaskSummary.receiptList.data.length > 0
                                 && !config.receiptList.isLoading)"
             [tooltip]="'Reports generieren'" flow="left">
          </i>
        </ng-template>
        <ng-template #contentTemplate>
          <div class="content">
<!--             <div class="md-menu-item" -->
<!--                  (click)="config.receiptTaskOpenTestReport()" -->
<!--                  [class.app-disabled]="!(TaskSummary?.receiptList?.data -->
<!--                                          && TaskSummary.receiptList.data.length > 0 -->
<!--                                          && !config.receiptList.isLoading)"> -->
<!--               {{getRessource('ReportFileTT', { -->
<!--                 fileextension: 'xlsx', -->
<!--                 entity: 'Vorgang' -->
<!--               })}} -->
<!--             </div> -->
            <div class="md-menu-item"
                 (click)="config.receiptTaskOpenTestReportPdf()"
                 [class.app-disabled]="!(TaskSummary?.receiptList?.data
                                         && TaskSummary.receiptList.data.length > 0
                                         && !config.receiptList.isLoading)">
              {{getRessource('ReportFileTT', {
                fileextension: 'pdf',
                entity: 'Vorgang'
              })}}
            </div>
<!--             <div class="md-menu-item" -->
<!--                  (click)="config.receiptCaseOpenTestReport()" -->
<!--                  [class.app-disabled]="!(TaskSummary?.receiptList?.data -->
<!--                                          && TaskSummary.receiptList.data.length > 0 -->
<!--                                          && !config.receiptList.isLoading)"> -->
<!--               {{getRessource('ReportFileTT', { -->
<!--                 fileextension: 'xlsx', -->
<!--                 entity: 'Auftrag' -->
<!--               })}} -->
<!--             </div> -->
            <div class="md-menu-item"
                 (click)="config.receiptCaseOpenTestReportPdf()"
                 [class.app-disabled]="!(TaskSummary?.receiptList?.data
                                         && TaskSummary.receiptList.data.length > 0
                                         && !config.receiptList.isLoading)">
              {{getRessource('ReportFileTT', {
                fileextension: 'pdf',
                entity: 'Auftrag'
              })}}
            </div>
          </div>
        </ng-template>
      </app-exg-dropdown>
      <i class="search-filter-seperator"></i>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="TaskSummary?.taskDetails?.isLoading">
  <div class="content md3-surface">
    <div class="splash loading">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-container>


